import PropTypes from "prop-types";
import { labelPropType, disabledPropType, onChangePropType, classNamePropType, namePropType } from "../../common";

/**
 * PropTypes for Checkbox component
 *
 * @property {boolean} [checked] - Checkbox checked state
 * @property {function} [onChange] - Change handler callback - receives new boolean value
 * @property {string} [label] - Label text displayed next to checkbox
 * @property {boolean} [disabled] - Disable checkbox interaction
 * @property {string} [name] - Checkbox name attribute for forms
 * @property {string} [className] - Additional CSS classes
 * @property {boolean} [indeterminate] - Show indeterminate state (partial selection)
 */
export const checkboxPropTypes = {
  checked: PropTypes.bool,
  onChange: onChangePropType,
  label: labelPropType,
  disabled: disabledPropType,
  name: namePropType,
  className: classNamePropType,
  indeterminate: PropTypes.bool,
};
